import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Youtube, Instagram, Twitch, MessageSquare } from "lucide-react";

interface SocialMediaInputsProps {
  youtubeUrl: string | null;
  instagramUrl: string | null;
  discordUrl: string | null;
  twitchUrl: string | null;
  onYoutubeChange: (value: string) => void;
  onInstagramChange: (value: string) => void;
  onDiscordChange: (value: string) => void;
  onTwitchChange: (value: string) => void;
}

export const SocialMediaInputs = ({
  youtubeUrl,
  instagramUrl,
  discordUrl,
  twitchUrl,
  onYoutubeChange,
  onInstagramChange,
  onDiscordChange,
  onTwitchChange,
}: SocialMediaInputsProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-2 text-white">Redes Sociais</h3>
      
      <div className="space-y-3">
        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <Youtube className="h-5 w-5 text-red-500" />
            Link do YouTube
          </Label>
          <Input
            placeholder="https://youtube.com/c/seucanal"
            value={youtubeUrl || ''}
            onChange={(e) => onYoutubeChange(e.target.value)}
            className="bg-gray-800 border-gray-700"
          />
        </div>

        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <Instagram className="h-5 w-5 text-pink-500" />
            Link do Instagram
          </Label>
          <Input
            placeholder="https://instagram.com/seuperfil"
            value={instagramUrl || ''}
            onChange={(e) => onInstagramChange(e.target.value)}
            className="bg-gray-800 border-gray-700"
          />
        </div>

        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-indigo-400" />
            Link do Discord
          </Label>
          <Input
            placeholder="https://discord.gg/seuserver"
            value={discordUrl || ''}
            onChange={(e) => onDiscordChange(e.target.value)}
            className="bg-gray-800 border-gray-700"
          />
        </div>

        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <Twitch className="h-5 w-5 text-purple-500" />
            Link da Twitch
          </Label>
          <Input
            placeholder="https://twitch.tv/seucanal"
            value={twitchUrl || ''}
            onChange={(e) => onTwitchChange(e.target.value)}
            className="bg-gray-800 border-gray-700"
          />
        </div>
      </div>
    </div>
  );
};
